import styled from "styled-components"

export const DivCheckbox = styled.div`
    margin-right: 20px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;

    .label{
        color: ${(props: any) => props.theme.colors.interfaceText400};
        font-size: 16px;
        line-height: 24px;
        margin-left: 10px;
    }

    .link {
        color: ${(props: any) => props.theme.colors.primaryRed400};
        font-size: 16px;
        line-height: 24px;
        text-decoration: underline;
        margin-left: 0px;
        cursor: pointer;
        
        &:hover {
            color: ${(props: any) => props.theme.colors.primaryRed500};
        }
    }

    .checkbox {
        display: flex;
        justify-content: left;
        cursor: pointer;
        .square{
            box-sizing: border-box;
            vertical-align: middle;
            display: inline-block;
            width: 22px;
            height: 22px;
            border: 2px solid ${(props: any) => props.theme.colors.interfaceGray100};
            border-radius: 3px;
            &:before{
                display: block;
                content: "✔";
                text-align: center;
                color: ${(props: any) => props.theme.colors.pureWhite};
                transition: .2s;
                opacity: 0;
            }
        }
        .text{
            display: inline-block;
            margin-left: 10px;
            vertical-align: middle;
            line-height: 22px;
        }
        &.active{
            .square{
                border: ${(props: any) => props.theme.colors.primaryRed400};
                background-color: ${(props: any) => props.theme.colors.primaryRed400};
                &:before{
                    opacity: 1;
                    color: ${(props: any) => props.theme.colors.pureWhite};
                }
            }
        }
        &.error{
            .square{
                border: 2px solid ${(props: any) => props.theme.colors.primaryRed400} !important;
            }
        }
    }

    @media (max-width: 800px) {
        margin: 0 auto;
        .label {
            width: 250px;
        }
    }
`;